/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    loading: false,
    updating: false,
    error: false,
    response: {},
};
const slice = createSlice({
    name: 'CommPreferencesSlice',
    initialState: initialState,
    reducers: {
        fetch(state, _action) {
            state.loading = true;
        },
        fetchSuccess(state, action) {
            state.loading = false;
            state.response = action.payload?.data;
        },
        fetchFailed(state, _action) {
            state.loading = false;
            state.error = true;
        },
        update(state, _action) {
            state.updating = true;
        },
        updateSuccess(state, action) {
            state.updating = false;
            state.response = action.payload?.data;
        },
        updateFailed(state, _action) {
            state.updating = false;
            state.error = true;
        },
        resetReducer(state, _action) {
            const stateData = { ...state };
            stateData.loading = initialState.loading;
            stateData.updating = initialState.updating;
            stateData.error = initialState.error;
            stateData.response = initialState.response;
        },
    },
});
export const actions = slice.actions;
export const sliceName = slice.name;
export const selectCommPreferences = (state) => state.commPreferencesReducer?.response;
const commPreferencesReducer = slice.reducer;
export default commPreferencesReducer;
